import { type AppErrorOptions, ConflictError } from "../../error/errors.ts";

export const DUPLICATE_EXPORT_TEMPLATE_NAME_ERROR_CODE = "DUPLICATE_EXPORT_TEMPLATE_NAME";

export class DuplicateExportTemplateNameError extends ConflictError {
  constructor(options?: AppErrorOptions) {
    super("Export template name already used for this type in this organisation", {
      ...options,
      code: DUPLICATE_EXPORT_TEMPLATE_NAME_ERROR_CODE,
      logLevel: "warn",
    });
    this.name = "DuplicateExportTemplateNameError";
  }
}
